import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { StorageService } from '../_services/storage.service';
import { LoginStorageKey } from './auth.constants';

let isNavigating = false;


@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private storageService: StorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


     // Allow OTP verification page if user is in OTP pending state
    if (this.storageService.getForVerifyOTP(LoginStorageKey.SECURITY_VERIFICATION) === 'Pending') {
      return false;
    }
    if (this.storageService.isLoggedIn()) {
      return true;
    }

    
    if (isNavigating) {
      return false;
    }

    isNavigating = true;
     
    this.router.navigate(['/auth/login'], {queryParams: {returnUrl: state.url}}).finally(() =>
      isNavigating = false
    );
    return false;
  }
}
